import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  MadMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type MadDocumentDeletedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: MadMinimalFragment;
};

export function isMadDocumentDeletedActivity(
  q: ActivityFragment
): q is MadDocumentDeletedActivity {
  return q.key === "mad.document_deleted";
}

interface MadDocumentDeletedActivityProps {
  activity: MadDocumentDeletedActivity;
}

export const MadDocumentDeletedActivity: React.FC<MadDocumentDeletedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="madDocumentDeletedActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.madDocumentDeleted", {
          mad: (
            <Link
              to={`/mads/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.mad")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
